import React from "react";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { useTranslation } from "react-i18next";
import { useHotels } from "../../hotels/hooks/useHotels";

type HotelsFilterSelectFieldProps = {
  value?: string | "all hotels";
  onChange: (value: string | "all hotels") => void;
  label?: string;
  error?: string;
  withLabel?: boolean;
  triggerClassName?: string;
};

export const HotelsFilterSelectField: React.FC<
  HotelsFilterSelectFieldProps
> = ({ value, onChange, label, error, withLabel = true, triggerClassName }) => {
  const { t } = useTranslation();
  const { data: hotels, isLoading } = useHotels();

  return (
    <div className="flex min-w-0 flex-col gap-1">
      {withLabel && (
        <label className="text-xs font-medium text-gray-700 uppercase">
          {label || t("hotels.hotel")}
        </label>
      )}

      <Select value={value} onValueChange={onChange}>
        <SelectTrigger
          className={`w-full border-2 focus:ring-0 focus:border-black hover:border-black ${triggerClassName ?? ""} ${
            error ? "border-red-500" : "border-black"
          }`}
        >
          <SelectValue
            placeholder={
              isLoading ? t("common.loading") : t("hotels.chooseHotel")
            }
          />
        </SelectTrigger>

        <SelectContent>
          <SelectItem value="all hotels">{t("hotels.allHotels")}</SelectItem>

          {hotels?.data?.map((hotel) => (
            <SelectItem key={hotel.id} value={hotel.id}>
              {hotel.name}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>

      {error && <span className="text-xs text-red-500">{error}</span>}
    </div>
  );
};

export default HotelsFilterSelectField;
